import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { usePipedriveStore, useTenantInMarketStore } from '../..';
import useTenantsInMarketWithFocusArea from '../../hooks/useTenantsInMarketWithFocusArea';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import useTenantsInMarketWithGlobalFilters from '../../interfaces/useTenantsInMarketWithGlobalFilters';
import GeometryService from '../../services/geometryService';
import TenantsInMarketGrid from '../tenantsInMarket/TenantsInMarketGrid';

function DealDetailsTenantsInMarketTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const pipedriveStore = usePipedriveStore();
    const tenantInMarketStore = useTenantInMarketStore();
    const deal = useMemo(() => computed(() => pipedriveStore.deals.find(d => d.id.toString() === id)!), [id]).get();
    const geometryService = useMemo(() => new GeometryService(), []);
    const tenantsInMarket = useTenantsInMarketWithFocusArea(useTenantsInMarketWithGlobalFilters(
        useMemo(() => computed(() => tenantInMarketStore.tenantsInMarket.filter(tim => geometryService.isPointInsideShape({ latitude: deal.lat, longitude: deal.lon }, tim.shape))), [deal]).get()
    ));

    useEffect(() => setEntityCount(tenantsInMarket.length), [tenantsInMarket]);

    if (!visible)
        return null;

    return <TenantsInMarketGrid tenantsInMarket={tenantsInMarket} />;
}

export default observer(DealDetailsTenantsInMarketTab);